import { Box, BoxProps, useColorModeValue } from "@chakra-ui/react";

type Props = {
  children: React.ReactNode;
  borderRadius?: "xs" | "sm" | "md";
} & BoxProps;

export const TableWrapper = ({
  children,
  borderRadius = "md",
  ...props
}: Props) => {
  const color = useColorModeValue("gray.100", "rgba(0, 0, 0, 0.15)");
  const bgColor = useColorModeValue("white", "#0f0f13");

  return (
    <Box
      bgColor={bgColor}
      px="6"
      py="2"
      borderWidth="1px"
      borderStyle="solid"
      borderColor={color}
      borderRadius={borderRadius}
      {...props}
    >
      {children}
    </Box>
  );
};
